import { render, staticRenderFns } from "./RecyclableBoxInStore.vue?vue&type=template&id=492f43df&scoped=true&"
import script from "./RecyclableBoxInStore.vue?vue&type=script&lang=js&"
export * from "./RecyclableBoxInStore.vue?vue&type=script&lang=js&"
import style0 from "./RecyclableBoxInStore.vue?vue&type=style&index=0&id=492f43df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492f43df",
  null
  
)

export default component.exports